"use client";
import { createSolanaRpc } from "@solana/kit";

import { getRpcUrl } from "@/lib/config";

type Rpc = ReturnType<typeof createSolanaRpc>;

let rpc: Rpc | null = null;

export const getSolanaRpc = (): Rpc => {
  if (rpc !== null) return rpc;
  const url = getRpcUrl();
  if (!url) {
    throw new Error(
      "NEXT_PUBLIC_RPC_URL is required to submit transactions or read accounts"
    );
  }
  rpc = createSolanaRpc(url);
  return rpc;
};
